import { render, staticRenderFns } from "./teachingSys.vue?vue&type=template&id=a8394b12"
import script from "./teachingSys.vue?vue&type=script&lang=js"
export * from "./teachingSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports